const ACTIVE_ORG_KEY_PREFIX = 'r42:active-org-id:';

function getStorageKey(userId: string): string {
  return `${ACTIVE_ORG_KEY_PREFIX}${userId}`;
}

export function getStoredActiveOrgId(userId?: string | null): string | null {
  if (!userId) {
    return null;
  }

  try {
    return sessionStorage.getItem(getStorageKey(userId));
  } catch {
    return null;
  }
}

export function setStoredActiveOrgId(userId: string, orgId: string | null): void {
  try {
    const storageKey = getStorageKey(userId);
    if (orgId) {
      sessionStorage.setItem(storageKey, orgId);
      return;
    }

    sessionStorage.removeItem(storageKey);
  } catch {
    // Ignore storage access failures in restricted browser modes.
  }
}